export class AssetState {
    id: number;
    code: string;
    name: string;
    isDeleted: boolean;
    modifiedAt: Date;
    state: any;
}